import React, { useState } from "react"
import Image from "next/image"
import imgBottom from "assets/img/image/img_about-bottom.png"
import imgThumbnail from "assets/img/image/img_about-youtube-thumbnail.jpeg"

//Utils
import { useRouter } from "next/router"
import {
  useIsomorphicLayoutEffect,
  useScrollAnim,
} from "@components/hooks/hooks"
import YouTube from "react-youtube"

const HandmadeComp = ({ locale, locales }) => {
  //Utils
  const Router = useRouter()
  const [trigger, anim] = useScrollAnim()
  const [isPlaying, setIsPlaying] = useState(false)

  // useIsomorphicLayoutEffect(() => {
  //   document.documentElement.classList.add("enable-sticky")
  // }, [])
  //React Operations ******************************************************************** //

  const videoOptions = {
    playerVars: {
      autoplay: 1,
      controls: 1,
      rel: 0,
      showinfo: 0,
      mute: 0,
      color: "white",
      fs: 1,
      modestbranding: 1,
    },
  }

  const handleThumbnailClick = () => {
    setIsPlaying(true)
  }

  return (
    <section className="sc-handmade" ref={trigger}>
      <div className="container mw-lg">
        <div className={`wrapper-content ${anim(1)}`}>
          <div className="embed-responsive embed-responsive-16by9">
            {!isPlaying ? (
              <div
                className="video-thumbnail-wrapper"
                onClick={handleThumbnailClick}
              >
                <Image
                  src={imgThumbnail}
                  alt="YouTube Video Thumbnail"
                  className="video-thumbnail"
                  fill
                  style={{ objectFit: "cover" }}
                />
                <div className="play-button-overlay">
                  <div className="play-button">
                    <i className="ais ai-play" />
                  </div>
                </div>
              </div>
            ) : (
              <YouTube
                videoId="udOQwzw-B9g"
                opts={videoOptions}
                className="embed-responsive-item"
              />
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default HandmadeComp
